"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const InputText = (0, react_1.forwardRef)((props, ref) => {
  const {
    placeholder,
    value,
    isDisabled,
    stylesOverride,
    label,
    labelColor = '#000000b3',
    dataAutomation = 'input-text',
    ...rest
  } = props;
  const theme = (0, styled_components_1.useTheme)();
  const onChange = (0, react_1.useCallback)(e => {
    if (isDisabled || !props.onChange) {
      return;
    }
    props.onChange(e);
  }, [isDisabled, props.onChange]);
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [label && (0, jsx_runtime_1.jsx)(styles_1.Label, {
      isMedium: !!theme.isMobile,
      fontSize: theme.isMobile ? '18px' : '14px',
      fontColor: labelColor,
      children: label
    }), (0, jsx_runtime_1.jsx)(styles_1.Input, {
      type: "text",
      autoComplete: "off",
      placeholder: placeholder,
      value: value,
      onChange: onChange,
      disabled: isDisabled,
      stylesOverride: stylesOverride,
      ref: ref,
      "data-automation": dataAutomation,
      ...rest
    })]
  });
});
exports.default = InputText;